export default __webpack_public_path__ + "static/media/right_arrow.3d51ac9b.svg";